import { appRoutes } from "../../../constants/appRoutes";

export const usefullLinksRoute = {
    path: appRoutes.usefullLinks.path,
    lazy: () => import('../../../pages/UsefullLinks'),
}